document.addEventListener('DOMContentLoaded', function () {
    const STADAMI_MEDIA_URL = 'https://stadami-public-dev.s3.eu-south-2.amazonaws.com/';
    const CLAIM_BUSINESS_URL = '/wp-json/stadami/v1/claim-business';
    const CONFIRM_OTP_URL = '/wp-json/stadami/v1/confirm-otp';
    const USER_ME_URL = '/wp-json/stadami/v1/me';
    const RESEND_OTP_URL = '/wp-json/stadami/v1/resend-otp';
    const placeholderImage = window.stadamiClaim?.placeholderImage || '';

    let secretKey = null;

    const card = document.querySelector('.js-claim-card');
    if (!card) return;

    const params = new URLSearchParams(window.location.search);

    const businessId = params.get('id');
    const claimCode = params.get('claim-code');

    console.log('Business ID:', businessId);
    console.log('Claim code:', claimCode);

    function getMediaUrl(path) {
        if (!path) return '';
        if (path.startsWith('http')) {
            return path;
        }
        return `${STADAMI_MEDIA_URL}${path}`;
    }

    function renderBusinessCard(business) {
        const image = business.photoUrl ? getMediaUrl(business.photoUrl) : placeholderImage;
        const title = business.displayName ? business.displayName : '';
        const categories = business.trainingTypes?.length ? business.trainingTypes.map(item => item.title).join(', ') : '';
        const address = [business.geoCity?.name, business.geoCountry?.name,].filter(Boolean).join(', ');
        const website = business.website ? business.website : '';

        card.innerHTML = `
      ${image ? `
        <div class="business-image-wrap">
          <img src="${image}" alt="${title}" class="business-image">
        </div>
      ` : ''}

      <div class="business-content">
        ${title ? `
                        <div class="subtitle-1 business-title">${title}</div>
                ` : ''}
        ${categories ? `<div class="business-meta">
                  <div class="business-meta-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8.00648 7.33366C8.37467 7.33366 8.67315 7.63214 8.67315 8.00033C8.67315 8.36852 8.37467 8.66699 8.00648 8.66699H7.99997C7.63178 8.66699 7.33331 8.36852 7.33331 8.00033C7.33331 7.63214 7.63178 7.33366 7.99997 7.33366H8.00648Z" fill="#576056"/>
          <path d="M9.99997 4.00033V2.66699C9.99997 2.49018 9.92969 2.32066 9.80466 2.19564C9.69523 2.08621 9.55173 2.01871 9.39906 2.00358L9.33331 2.00033H6.66664C6.48983 2.00033 6.32031 2.07061 6.19529 2.19564C6.07026 2.32066 5.99997 2.49018 5.99997 2.66699V4.00033C5.99997 4.36852 5.7015 4.66699 5.33331 4.66699C4.96512 4.66699 4.66664 4.36852 4.66664 4.00033V2.66699C4.66664 2.13656 4.87751 1.628 5.25258 1.25293C5.62765 0.877857 6.13621 0.666992 6.66664 0.666992H9.33331C9.86374 0.666992 10.3723 0.877857 10.7474 1.25293C11.1224 1.628 11.3333 2.13656 11.3333 2.66699V4.00033C11.3333 4.36852 11.0348 4.66699 10.6666 4.66699C10.2985 4.66699 9.99997 4.36852 9.99997 4.00033Z" fill="#576056"/>
          <path d="M14.2995 8.11035C14.6067 7.90768 15.0205 7.99261 15.2233 8.2998C15.426 8.60705 15.341 9.02082 15.0338 9.22363C13.0772 10.5154 10.8051 11.2414 8.46807 11.3271L7.99997 11.3356C5.4991 11.3356 3.0532 10.6015 0.96612 9.22363C0.658927 9.02082 0.57399 8.60705 0.776666 8.2998C0.979478 7.99261 1.39325 7.90768 1.70049 8.11035C3.56964 9.34438 5.76021 10.0023 7.99997 10.0023L8.41924 9.99512C10.5123 9.91833 12.5471 9.26727 14.2995 8.11035Z" fill="#576056"/>
          <path d="M14 5.33366C14 4.96547 13.7015 4.66699 13.3333 4.66699H2.66664C2.29845 4.66699 1.99997 4.96547 1.99997 5.33366V12.0003C1.99997 12.3685 2.29845 12.667 2.66664 12.667H13.3333C13.7015 12.667 14 12.3685 14 12.0003V5.33366ZM15.3333 12.0003C15.3333 13.1049 14.4379 14.0003 13.3333 14.0003H2.66664C1.56207 14.0003 0.66664 13.1049 0.66664 12.0003V5.33366C0.66664 4.22909 1.56207 3.33366 2.66664 3.33366H13.3333C14.4379 3.33366 15.3333 4.22909 15.3333 5.33366V12.0003Z" fill="#576056"/>
        </svg> <span>${categories}</span></div>
               ` : ''}
        ${address ? `
                    <div class="business-meta-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.00033C6.52724 4.00033 5.33333 5.19423 5.33333 6.66699C5.33333 8.13975 6.52724 9.33366 8 9.33366C9.47276 9.33366 10.6667 8.13975 10.6667 6.66699C10.6667 5.19423 9.47276 4.00033 8 4.00033ZM6.66667 6.66699C6.66667 5.93061 7.26362 5.33366 8 5.33366C8.73638 5.33366 9.33333 5.93061 9.33333 6.66699C9.33333 7.40337 8.73638 8.00033 8 8.00033C7.26362 8.00033 6.66667 7.40337 6.66667 6.66699Z" fill="#576056"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0.666992C6.4087 0.666992 4.88258 1.29913 3.75736 2.42435C2.63214 3.54957 2 5.07569 2 6.66699C2 8.55611 3.03522 10.4022 4.13751 11.8505C5.25525 13.3191 6.52685 14.4878 7.16364 15.0376C7.175 15.0474 7.18668 15.0568 7.19867 15.0658C7.4297 15.2396 7.71094 15.3335 8 15.3335C8.28906 15.3335 8.5703 15.2396 8.80133 15.0658C8.81332 15.0568 8.825 15.0474 8.83636 15.0376C9.47315 14.4878 10.7448 13.3191 11.8625 11.8505C12.9648 10.4022 14 8.55611 14 6.66699C14 5.07569 13.3679 3.54957 12.2426 2.42435C11.1174 1.29913 9.5913 0.666992 8 0.666992ZM4.70017 3.36716C5.57534 2.49199 6.76232 2.00033 8 2.00033C9.23768 2.00033 10.4247 2.49199 11.2998 3.36716C12.175 4.24233 12.6667 5.42932 12.6667 6.66699C12.6667 8.10654 11.8555 9.6581 10.8015 11.043C9.78265 12.3816 8.61354 13.4657 8 13.9981C7.38646 13.4657 6.21735 12.3816 5.19849 11.043C4.14445 9.6581 3.33333 8.10654 3.33333 6.66699C3.33333 5.42932 3.825 4.24233 4.70017 3.36716Z" fill="#576056"/>
        </svg><span>${address}</span></div>
                  ` : ''}
        ${website ? `
                    <a class="business-meta-item business-link " href="${website}" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clip-path="url(#clip0_66849_13183)">
            <path d="M11.3307 0.711089C12.3794 0.720271 13.3827 1.14139 14.1243 1.88296C14.8658 2.62457 15.2864 3.62792 15.2955 4.67658C15.3046 5.72516 14.9016 6.73541 14.1731 7.48973L12.1647 9.4982C11.7592 9.90381 11.271 10.2177 10.7337 10.4181C10.1963 10.6185 9.62213 10.7006 9.05009 10.6597C8.47799 10.6187 7.92127 10.4555 7.41793 10.1805C6.9146 9.90549 6.47632 9.52519 6.13277 9.06591C5.91236 8.77108 5.97275 8.35347 6.26754 8.13296C6.56236 7.91255 6.97998 7.97294 7.20048 8.26773C7.4295 8.57386 7.72174 8.82726 8.05725 9.01057C8.39275 9.19386 8.76382 9.30289 9.14514 9.33023C9.52644 9.35754 9.90935 9.30233 10.2675 9.16877C10.6258 9.03512 10.9516 8.82593 11.222 8.55549L13.2135 6.56395C13.6993 6.06101 13.9683 5.38684 13.9622 4.68765C13.9561 3.98868 13.6758 3.32001 13.1816 2.82567C12.6872 2.33128 12.0181 2.05053 11.319 2.04442C10.6198 2.03835 9.94625 2.30739 9.44332 2.79312L9.44267 2.79247L8.30334 3.92593C8.04224 4.18552 7.62023 4.18444 7.36064 3.92333C7.10107 3.66222 7.10214 3.2402 7.36324 2.98062L8.50972 1.84065C8.51198 1.8384 8.5146 1.83635 8.51689 1.83414C9.27129 1.1055 10.2819 0.701975 11.3307 0.711089Z" fill="#3D6124"/>
            <path d="M6.9497 5.34047C7.52177 5.38144 8.07853 5.54466 8.58186 5.81964C9.08521 6.09464 9.52345 6.47492 9.86701 6.93422C10.0875 7.22897 10.0275 7.64658 9.7329 7.86717C9.4381 8.08768 9.01986 8.02779 8.7993 7.73305C8.57026 7.42685 8.2781 7.1729 7.94253 6.98956C7.60703 6.8063 7.23596 6.69722 6.85464 6.6699C6.47332 6.64259 6.09045 6.69777 5.73225 6.83136C5.37398 6.965 5.04816 7.1742 4.77782 7.44464L2.78563 9.43618C2.2999 9.93911 2.03151 10.6133 2.03759 11.3125C2.0437 12.0116 2.32445 12.6807 2.81884 13.1751C3.31317 13.6693 3.98184 13.9496 4.68082 13.9557C5.38001 13.9618 6.05418 13.6928 6.55712 13.207L7.68863 12.0755C7.94898 11.8151 8.37099 11.8151 8.63134 12.0755C8.89165 12.3359 8.89167 12.7579 8.63134 13.0182L7.4829 14.1666C6.72858 14.8951 5.71832 15.2981 4.66975 15.289C3.62108 15.2799 2.61773 14.8593 1.87613 14.1178C1.13456 13.3762 0.713436 12.3729 0.704253 11.3242C0.695139 10.2754 1.09867 9.2648 1.8273 8.51039L1.83511 8.50193L3.83511 6.50193C4.2406 6.09632 4.72874 5.78246 5.2661 5.58201C5.80344 5.38159 6.37767 5.29952 6.9497 5.34047Z" fill="#3D6124"/>
          </g><defs><clipPath id="clip0_66849_13183"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
        <span class="body-link">${website}</span></a>
                  ` : ''}      
        <div class="claim-action js-claim-action">
          <button type="button" class="btn-primary hide-icon js-open-claim-form">Claim business</button>
        </div>
        <form class="claim-form js-claim-form" novalidate style="display: none;">
             <div class="subtitle-form body-large">Create your account to claim this business</div>
             <div class="form-group">
                    <label for="claim_email">Email</label>
                    <input
                      type="email"
                      id="claim_email"
                      name="email"
                      placeholder="Enter email"
                      autocomplete="email"
                    >
                    <div class="field-error"></div>
                  </div>
             <div class="form-group">
                <label for="claim_password">Password</label>
            
                <div class="password-wrap">
                  <input
                    type="password"
                    id="claim_password"
                    name="password"
                    placeholder="Enter password"
                    autocomplete="new-password"
                  >
            
                  <button type="button" class="password-toggle js-password-toggle" aria-label="Show password">
                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                             fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M12.0005 6.00098C10.0696 6.00098 8.18216 6.57431 6.57748 7.6483C4.98279 8.71561 3.73872 10.2296 3.00076 12.0004C3.73872 13.7711 4.98279 15.2851 6.57748 16.3524C8.18216 17.4264 10.0696 17.9997 12.0005 17.9997C13.9314 17.9997 15.8189 17.4264 17.4235 16.3524C19.0182 15.2851 20.2623 13.7711 21.0002 12.0004C20.2623 10.2296 19.0182 8.71561 17.4235 7.6483C15.8189 6.57431 13.9314 6.00098 12.0005 6.00098ZM5.46507 5.98622C7.39891 4.69192 9.67351 4.00098 12.0005 4.00098C14.3275 4.00098 16.6021 4.69192 18.5359 5.98622C20.4698 7.28051 21.9758 9.11986 22.863 11.2711C22.8675 11.2821 22.8719 11.2932 22.876 11.3044C23.0427 11.7534 23.0427 12.2473 22.876 12.6964C22.8719 12.7075 22.8675 12.7186 22.863 12.7296C21.9758 14.8809 20.4698 16.7202 18.5359 18.0145C16.6021 19.3088 14.3275 19.9997 12.0005 19.9997C9.67351 19.9997 7.39891 19.3088 5.46507 18.0145C3.53123 16.7202 2.02525 14.8809 1.13804 12.7296C1.1335 12.7186 1.12916 12.7075 1.12501 12.6964C0.95833 12.2473 0.95833 11.7534 1.12501 11.3044C1.12916 11.2932 1.1335 11.2821 1.13804 11.2711C2.02525 9.11986 3.53123 7.28051 5.46507 5.98622ZM12.0005 10.0004C10.8959 10.0004 10.0005 10.8958 10.0005 12.0004C10.0005 13.1049 10.8959 14.0004 12.0005 14.0004C13.1051 14.0004 14.0005 13.1049 14.0005 12.0004C14.0005 10.8958 13.1051 10.0004 12.0005 10.0004ZM8.00051 12.0004C8.00051 9.79122 9.79137 8.00036 12.0005 8.00036C14.2096 8.00036 16.0005 9.79122 16.0005 12.0004C16.0005 14.2095 14.2096 16.0004 12.0005 16.0004C9.79137 16.0004 8.00051 14.2095 8.00051 12.0004Z"
                                                  fill="#474846"/>
                                        </svg>
                  </button>
                </div>
    
                <div class="field-hint">
                  Use 8+ characters, letters, numbers, and 1 uppercase or symbol.
                </div>
            
                <div class="field-error"></div>
              </div>
             <div class="wrap-submit">
                <button type="submit" class="btn-primary hide-icon">Claim business</button>
                <div class="loader-signup"></div>
             </div>
         </form>
        <div class="claim-otp js-claim-otp" style="display: none;">
             <p>
                Enter the 4-digit code sent to
                <strong class="js-claim-user-email"></strong>
              </p>
             <div class="code-inputs">
                <input type="text" inputmode="numeric" maxlength="1">
                <input type="text" inputmode="numeric" maxlength="1">
                <input type="text" inputmode="numeric" maxlength="1">
                <input type="text" inputmode="numeric" maxlength="1">
              </div>
             <div class="field-error js-code-error"></div>
             <div class="wrap-submit verify">
                <button type="button" class="btn-primary hide-icon js-verify-claim-code">Verify email</button>
                <div class="loader-signup"></div>
              </div>
             <div class="resend-code">
                Didn’t receive the code?
                <button type="button" class="js-resend-btn disabled">Resend</button>
                <span class="resend-timer">in <strong class="js-timer">0:59</strong></span>
              </div>
         </div>
        <ul class="claim-benefits js-claim-benefits">
          <li>Manage your business profile</li>
          <li>Get discovered by nearby clients</li>
          <li>Receive direct inquiries</li>
         </ul>
      </div>
    `;
    }

    function setError(input, message) {
        const group = input.closest('.form-group');
        const error = group.querySelector('.field-error');
        group.classList.add('has-error');
        group.classList.remove('show-hint');
        error.textContent = message;
    }

    function clearError(input) {
        const group = input.closest('.form-group');
        const error = group.querySelector('.field-error');
        group.classList.remove('has-error');
        error.textContent = '';
    }

    function validateEmail(input) {
        const value = input.value.trim();
        clearError(input);

        if (!value) {
            setError(input, 'Please enter your email.');
            return false;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            setError(input, 'Enter a valid email address.');
            return false;
        }

        return true;
    }

    function validatePassword(input) {
        const value = input.value;

        clearError(input);

        if (!value) {
            setError(input, 'Please enter a password.');
            return false;
        }

        if (value.length < 8) {
            setError(input, 'Must be at least 8 characters.');
            return false;
        }

        if (!/[A-Za-z]/.test(value) || !/[0-9]/.test(value)) {
            setError(input, 'Must contain numbers and letters.');
            return false;
        }

        if (!/[A-Z]/.test(value) && !/[^A-Za-z0-9]/.test(value)) {
            setError(input, 'Must contain uppercase or special symbols.');
            return false;
        }

        return true;
    }

    function setLoading(wrapper, isLoading) {
        if (!wrapper) return;
        wrapper.classList.toggle('loading', isLoading);
    }

    function showCodeError(message) {
        const codeError = document.querySelector('.js-code-error');
        const codeInputs = document.querySelectorAll('.code-inputs input');

        if (!codeError) return;

        codeError.textContent = message;
        codeError.style.display = 'block';

        codeInputs.forEach(input => input.classList.add('has-error'));
    }

    function clearCodeError() {
        const codeError = document.querySelector('.js-code-error');
        const codeInputs = document.querySelectorAll('.code-inputs input');

        if (!codeError) return;

        codeError.textContent = '';
        codeError.style.display = 'none';

        codeInputs.forEach(input => input.classList.remove('has-error'));
    }


    function initClaimForm() {
        const openBtn = document.querySelector('.js-open-claim-form');
        const claimAction = document.querySelector('.js-claim-action');
        const claimForm = document.querySelector('.js-claim-form');
        const claimBenefits = document.querySelector('.js-claim-benefits');

        if (!openBtn || !claimForm) return;

        const emailInput = claimForm.querySelector('[name="email"]');
        const passwordInput = claimForm.querySelector('[name="password"]');
        const passwordToggle = claimForm.querySelector('.js-password-toggle');
        const claimSubmitWrap = claimForm.querySelector('.wrap-submit');

        let emailTouched = false;
        let passwordTouched = false;

        openBtn.addEventListener('click', function () {
            claimAction.style.display = 'none';
            claimForm.style.display = 'block';
        });

        emailInput.addEventListener('input', function () {
            if (!emailTouched) return;
            validateEmail(emailInput);
        });

        emailInput.addEventListener('blur', function () {
            emailTouched = true;
            validateEmail(emailInput);
        });

        passwordInput.addEventListener('input', function () {
            if (!passwordTouched) return;
            validatePassword(passwordInput);
        });

        passwordInput.addEventListener('focus', function () {
            passwordTouched = true;

            const group = passwordInput.closest('.form-group');
            if (!group.classList.contains('has-error')) {
                group.classList.add('show-hint');
            }
        });

        passwordInput.addEventListener('blur', function () {
            validatePassword(passwordInput);
            passwordInput.closest('.form-group').classList.remove('show-hint');
        });

        passwordToggle?.addEventListener('click', function () {
            passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
        });

        claimForm.addEventListener('submit', async function (e) {
            e.preventDefault();

            emailTouched = true;
            passwordTouched = true;

            const isEmailValid = validateEmail(emailInput);
            const isPasswordValid = validatePassword(passwordInput);

            if (!isEmailValid || !isPasswordValid) return;

            try {

                setLoading(claimSubmitWrap, true);

                const response = await fetch(CLAIM_BUSINESS_URL, {
                    method: 'POST',
                    headers: {
                        accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        userId: businessId,
                        claimCode: claimCode,
                        email: emailInput.value.trim(),
                        password: passwordInput.value,
                    }),
                });

                const data = await response.json();

                console.log('Claim business response:', data);

                if (!response.ok) {
                    setError(emailInput, data.message || data.error || 'Claim failed.');
                    return;
                }

                secretKey = data.secretKey;

                if (!secretKey) {
                    setError(emailInput, 'Secret key was not returned from server.');
                    return;
                }

                const claimOtp = document.querySelector('.js-claim-otp');
                const claimEmail = document.querySelector('.js-claim-user-email');

                claimForm.style.display = 'none';
                claimBenefits.style.display = 'none';

                if (claimOtp) {
                    claimOtp.style.display = 'block';
                }

                if (claimEmail) {
                    claimEmail.textContent = emailInput.value.trim();
                }

                initClaimOtp();
                startResendTimer(59);

                console.log('Claim secretKey:', secretKey);

            } catch (error) {
                console.log('Claim business error:', error);
                setError(emailInput, 'Something went wrong. Please try again.');
            } finally {
                setLoading(claimSubmitWrap, false);
            }
        });
    }

    let resendTimerInterval = null;

    function startResendTimer(duration = 59) {
        const resendBtn = document.querySelector('.js-resend-btn');
        const resendTimer = document.querySelector('.js-timer');
        const resendTimerText = document.querySelector('.resend-timer');

        if (!resendBtn || !resendTimer) return;

        let timeLeft = duration;

        clearInterval(resendTimerInterval);

        resendBtn.classList.add('disabled');

        if (resendTimerText) {
            resendTimerText.style.display = '';
        }

        resendTimer.textContent = `0:${String(timeLeft).padStart(2, '0')}`;

        resendTimerInterval = setInterval(function () {
            timeLeft--;

            resendTimer.textContent = `0:${String(timeLeft).padStart(2, '0')}`;

            if (timeLeft <= 0) {
                clearInterval(resendTimerInterval);
                resendTimer.textContent = '0:00';
                resendBtn.classList.remove('disabled');

                if (resendTimerText) {
                    resendTimerText.style.display = 'none';
                }
            }
        }, 1000);
    }

    function initClaimOtp() {
        const otpWrap = document.querySelector('.js-claim-otp');
        if (!otpWrap || otpWrap.dataset.initialized === 'true') return;

        otpWrap.dataset.initialized = 'true';

        const verifyBtn = otpWrap.querySelector('.js-verify-claim-code');
        const codeInputs = otpWrap.querySelectorAll('.code-inputs input');
        const verifyWrap = otpWrap.querySelector('.wrap-submit.verify');
        const resendBtn = otpWrap.querySelector('.js-resend-btn');

        codeInputs.forEach((input, index) => {
            input.addEventListener('input', function () {
                this.value = this.value.replace(/\D/g, '');
                clearCodeError();

                if (this.value && codeInputs[index + 1]) {
                    codeInputs[index + 1].focus();
                }
            });

            input.addEventListener('keydown', function (e) {
                if (e.key === 'Backspace' && !this.value && codeInputs[index - 1]) {
                    codeInputs[index - 1].focus();
                }
            });

            input.addEventListener('paste', function (e) {
                e.preventDefault();

                const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4);

                pasted.split('').forEach((number, i) => {
                    if (codeInputs[i]) {
                        codeInputs[i].value = number;
                    }
                });

                if (pasted.length === 4) {
                    codeInputs[3].focus();
                }
            });
        });

        verifyBtn?.addEventListener('click', async function () {
            clearCodeError();

            const code = Array.from(codeInputs).map(input => input.value).join('');

            if (code.length !== 4) {
                showCodeError('Enter 4-digits code.');
                return;
            }

            if (!secretKey) {
                showCodeError('Secret key is missing.');
                return;
            }

            try {
                setLoading(verifyWrap, true);

                const otpResponse = await fetch(CONFIRM_OTP_URL, {
                    method: 'POST',
                    headers: {
                        accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        secretKey: secretKey,
                        secretCode: Number(code),
                    }),
                });

                const otpData = await otpResponse.json();

                console.log('Claim OTP response:', otpData);

                if (!otpResponse.ok) {
                    showCodeError(otpData.message || otpData.error || 'Incorrect code. Try again.');
                    return;
                }

                const accessToken = otpData?.access?.token;

                if (!accessToken) {
                    showCodeError('Access token missing.');
                    return;
                }

                const userResponse = await fetch(USER_ME_URL, {
                    method: 'GET',
                    headers: {
                        accept: 'application/json',
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                const userData = await userResponse.json();

                console.log('Claim user me response:', userData);

                if (!userResponse.ok) {
                    showCodeError(userData.message || userData.error || 'Could not get user data.');
                    return;
                }

                const promoCode = userData.subscriptionCode;

                if (promoCode) {
                    sessionStorage.setItem('stadami_promo_code', promoCode);
                }

                window.location.href = '/registered-business//';

            } catch (error) {
                console.log('Claim OTP error:', error);
                showCodeError('Something went wrong. Please try again.');
            } finally {
                setLoading(verifyWrap, false);
            }
        });

        resendBtn?.addEventListener('click', async function () {
            if (this.classList.contains('disabled')) return;

            if (!secretKey) {
                showCodeError('Secret key is missing.');
                return;
            }

            try {
                this.classList.add('disabled');

                const response = await fetch(RESEND_OTP_URL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        secretKey: secretKey,
                    }),
                });

                const data = await response.json();

                console.log('Claim resend response:', data);

                if (!response.ok) {
                    showCodeError(data.message || data.error || 'Could not resend code.');
                    this.classList.remove('disabled');
                    return;
                }

                if (data.secretKey) {
                    secretKey = data.secretKey;
                }

                clearCodeError();
                startResendTimer(59);

            } catch (error) {
                console.log('Claim resend failed:', error);
                showCodeError('Could not resend code. Please try again.');
                this.classList.remove('disabled');
            }
        });
    }

    async function loadBusiness() {
        if (!businessId) {
            card.innerHTML = '<div class="business-error">Business ID is missing.</div>';
            return;
        }

        try {
            const response = await fetch(`/wp-json/stadami/v1/business/${businessId}`);
            const data = await response.json();

            console.log('Business data:', data);

            if (!response.ok) {
                card.innerHTML = '<div class="business-error">Business not found.</div>';
                return;
            }

            renderBusinessCard(data);
            initClaimForm();

        } catch (error) {
            console.log('Business load error:', error);
            card.innerHTML = '<div class="business-error">Could not load business.</div>';
        }
    }

    loadBusiness();
});